export const pastorBio = {
  name: 'Dr. David Ogbueli',
  title: 'Minister of the Gospel, Social Reformer, Transformational Leader',
  shortSummary:
    'A Minister of the Gospel, a Social Reformer, and an iconic transformational leader with great passion for Personal Transformation and National Transformation.',
  fullBio: [
    'Dr. David Ogbueli is a Minister of the Gospel, a Social Reformer, and an iconic transformational leader. He has great passion for Personal Transformation and National Transformation which has birthed various initiatives and ministries causing a positive change among the youth, governments, corporate institutions, the media and other stakeholders both in Africa and globally.',
    'He is a Management and Public Policy Consultant to private & public sector institutions and their leaders. He is a widely read author with over one hundred and fifty books published. A widely sought after clergyman, technocrat and teacher. He has a burning passion for human capital development as a key to nation building; his other interests are social reforms, transformational leadership, and nation transformation.',
    'He is the President of Golden Heart Foundation & National Development Centre set up to train & equip Nigerian & African youths on transformational leadership. He also seats on the board of Institute of National Transformation. He has been honoured by the United Nations, state governments, government agencies, corporate agencies & organisations for his youth development projects especially the annual National Youth Summit that empowers over 50,000 youths annually.',
    'He is a member of National Institute for Public Policy & Strategic Studies, an alumnus of Lagos Business School, and IESE Business School in Spain. He seats on the board of six big organisations with a focus on development & transformation. His media broadcast reaches seven continents with increasing transformational influence on many lives, communities, cities & nations.',
  ],
  roles: [
    'President, Golden Heart Foundation & National Development Centre',
    'Board Member, Institute of National Transformation',
    'Member, National Institute for Public Policy & Strategic Studies',
    'Alumnus, Lagos Business School',
    'Alumnus, IESE Business School (Spain)',
  ],
  family: 'He is married to Sarah Ogbueli and blessed with four children.',
  tags: 'Author · Speaker · Social Reformer · Management Consultant · Public Policy Expert',
};

export const aboutHubCards = [
  {
    title: 'About Dr David',
    description: `Meet ${pastorBio.name} and learn more about his ministry and calling.`,
    href: '/about',
  },
] as const;

export const aboutLinks = [
  { label: 'Overview', href: '/about' },
] as const;

export const ministryHubCards = [
  {
    title: 'Core Values',
    description: 'The convictions that shape how we serve and lead.',
    href: '/ministry/core-values',
  },
  {
    title: 'Statement of Faith',
    description: 'The biblical beliefs that anchor the ministry.',
    href: '/ministry/statement-of-faith',
  },
  {
    title: 'About Dominion Mandate',
    description: 'A concise overview of our ministry, mission, and direction.',
    href: '/ministry',
  },
] as const;

export const ministryLinks = [
  { label: 'About Dominion Mandate', href: '/ministry' },
  { label: 'Core Values', href: '/ministry/core-values' },
  { label: 'Statement of Faith', href: '/ministry/statement-of-faith' },
] as const;

export const publicCtas = [
  { label: 'Contact', href: '/contact' },
  { label: 'Give', href: '/give' },
  { label: 'Media Center', href: '/media' },
  { label: 'Learn more', href: '/about' },
] as const;

export const visionStatement =
  'Raising leaders that transform society through personal transformation and national transformation initiatives.';

export const coreValues = [
  {
    icon: 'Target' as const,
    title: 'Personal Transformation',
    description: 'Total man transformation through Christ — spiritual, mental, and social renewal that equips believers to lead and impact their world.',
  },
  {
    icon: 'Heart' as const,
    title: 'National Transformation',
    description: "A strong quest for transforming nations through leadership development, youth empowerment, and strategic partnerships.",
  },
  {
    icon: 'Zap' as const,
    title: 'Excellence & Quality',
    description: 'An uncompromising stand for high standards in every aspect of ministry and life. We serve a God of excellence.',
  },
  {
    icon: 'Shield' as const,
    title: 'Integrity',
    description: 'A commitment to righteousness and character. Our word is our bond and our conduct reflects Christ.',
  },
  {
    icon: 'Users' as const,
    title: 'Community',
    description: 'Building strong fellowships and authentic connections among believers. Community is at the heart of everything we do.',
  },
  {
    icon: 'Globe' as const,
    title: 'Global Impact',
    description: 'Transforming society at large through media broadcast reaching seven continents with increasing transformational influence.',
  },
];

export const faithStatements = [
  {
    icon: 'BookOpen' as const,
    title: 'The Scriptures',
    description:
      'We believe the Bible is the inspired Word of God, the infallible and authoritative rule of faith and conduct.',
  },
  {
    icon: 'Feather' as const,
    title: 'The Godhead',
    description:
      'We believe in one God eternally existing in three persons — Father, Son, and Holy Spirit.',
  },
  {
    icon: 'Cross' as const,
    title: 'Salvation',
    description:
      'We believe in salvation through faith in Jesus Christ, who died for our sins, was buried, and rose again on the third day.',
  },
  {
    icon: 'Church' as const,
    title: 'The Church',
    description:
      'We believe in the Church as the body of Christ, called to worship God, edify believers, and evangelize the world.',
  },
  {
    icon: 'Heart' as const,
    title: 'Holy Living',
    description:
      'We believe in living a holy and separated life, following the example and teachings of our Lord Jesus Christ.',
  },
  {
    icon: 'Globe' as const,
    title: 'The Great Commission',
    description:
      'We believe in fulfilling the Great Commission — going into all the world and making disciples of all nations.',
  },
];

export const ministries = [
  { badge: 'Dominion City', title: 'Church Ministry', description: 'A church ministry founded to raise leaders that transform societies with over 1,000 chapters worldwide with presence in America, Europe, the Middle East, Asia and Africa with regional offices in US, UK & Nigeria.' },
  { badge: 'Global Leadership Forum', title: 'Mentorship & Training', description: 'A mentorship & training platform established for human capital development & transformational leadership for exponential growth in performance & productivity in any field of endeavour.' },
  { badge: 'GMN', title: 'Global Missions Network', description: 'An alliance of global apostolic leaders with a common mandate to expand the reach of the Gospel & transforming nations.' },
  { badge: 'DLI', title: 'Dominion Leadership Institute', description: 'A training institute established for personal & ministry leadership development. DLI has produced over 30,000 graduates making tremendous impacts around the world.' },
  { badge: 'Golden Heart Foundation', title: 'Non-Profit', description: 'A non-profit organization with a strong focus on youth empowerment & development. The host of the National Youth Summit, an annual youth program with over 50,000 participants annually from across Africa.' },
  { badge: 'Huram Development', title: 'Construction', description: 'A building & construction company with strong competencies in architecture & project management having ongoing large-scale projects of mega auditoriums, estates and universities.' },
  { badge: 'Priesthood Institute', title: 'Ministerial College', description: 'A ministerial college established to train ministry professionals in competence, capacity, charisma & skillset required for the last day move of God.' },
];

export const importedSiteImages = {
  aboutHero: '/davidogbueli/hn-l.d16bcb5d5c632895ddbb.png',
  aboutPortrait: '/davidogbueli/P-2.ac30fbcfafe114d57716.png',
  contactHero: '/davidogbueli/hn-l.d16bcb5d5c632895ddbb.png',
  giveHonor: '/davidogbueli/gift-2.d0db94a519c17e231188.jpg',
  giveDonate: '/davidogbueli/donate.89d5c648062868fc8650.png',
  givePartner: '/davidogbueli/partner.c8845a089582c781856e.jpg',
  mediaVideo: '/davidogbueli/v-p.1bf8b34c6cb4e722ec67.jpg',
  mediaAudio: '/davidogbueli/a-p.6a09fd72acb1000cab6b.jpg',
  mediaGmtv: '/davidogbueli/GMTV.f273d6e1d4655b7c7edd.png',
  mediaRadio: '/davidogbueli/dmr-2.b4daf289522b71d308c6.jpeg',
  mentorshipHero: '/davidogbueli/hn-l.d16bcb5d5c632895ddbb.png',
  ministryHero: '/davidogbueli/hn-l.d16bcb5d5c632895ddbb.png',
  ministryDominionCity: '/davidogbueli/dc.cd4c905a45136400aded.jpg',
  ministryGlf: '/davidogbueli/GLF.7c69308223bd2fab04c6.jpg',
  ministryGmn: '/davidogbueli/GMN.143d2d15d45740a2fc91.jpg',
  ministryDli: '/davidogbueli/dli.5b1b2c7608eb7dfe5237.jpg',
  ministryGhf: '/davidogbueli/ghf.88d8e759381b35d0a7b8.jpg',
  ministryHuram: '/davidogbueli/hd.18c471322f29823b2648.jpg',
  ministryPriesthood: '/davidogbueli/pi.97e65b4e2204755c9c56.jpg',
  gmtvHero: '/davidogbueli/GMTV.f273d6e1d4655b7c7edd.png',
} as const;

export const contactDetails = {
  primary: {
    email: 'mail@davidogbueli.org',
    phones: ['+234-8035508230', '+234-8034954566'],
  },
  offices: [
    {
      name: 'US Office',
      address: ['1127 Misty Valley Court, Lawrenceville,', 'GA. 30045 (Georgia)', 'United States'],
      phones: ['+1-470-535-2006', '+1-678-622-7090'],
    },
    {
      name: 'UK Office',
      address: ['The Hub, 123 Star Lane,', 'London', 'E16 4PZ', 'United Kingdom'],
      phones: ['+44-7956670069', '+44-7760919119'],
    },
    {
      name: 'Abuja Office',
      address: ['17 Oladipo Diya Way,', 'Gudu District,', 'FCT, Abuja,', 'Nigeria'],
      phones: ['+234-8038246281', '+234-7060574969'],
    },
    {
      name: 'Lagos Office',
      address: ['Km 22, Lekki-Epe Expressway,', 'beside Lagos Business School,', 'Ajah, Lekki, Lagos', 'Nigeria'],
      phones: ['+234-8034954566', '+234-8035508230'],
    },
  ],
} as const;

export const giveOptions = [
  {
    title: 'Honour Dr David',
    description: 'Give in honour of Dr David via card payment or bank transfer.',
    image: importedSiteImages.giveHonor,
    actions: [
      { label: 'Card Payment', href: 'https://www.dominioncity.cc/give/honour' },
      { label: 'Bank Transfer', href: 'https://www.davidogbueli.org/bank-transfer' },
    ],
  },
  {
    title: 'Donations',
    description: 'Support projects and outreach through secure online giving.',
    image: importedSiteImages.giveDonate,
    actions: [{ label: 'Donate', href: 'https://www.dominioncity.cc/give/projects' }],
  },
  {
    title: 'Partnership',
    description: 'Become a partner and help expand the reach of the ministry.',
    image: importedSiteImages.givePartner,
    actions: [{ label: 'Partner', href: 'https://www.dominioncity.cc/give/partner' }],
  },
] as const;

export const mediaCenterCards = [
  {
    title: 'Video On Demand',
    description: 'Watch sermons, teachings, and video archives on demand.',
    image: importedSiteImages.mediaVideo,
    cta: 'Watch',
    href: '/broadcast',
  },
  {
    title: 'Audio On Demand',
    description: 'Listen to sermons and audio teachings from anywhere.',
    image: importedSiteImages.mediaAudio,
    cta: 'Listen',
    href: '/resources',
  },
  {
    title: 'Global Missions TV (GMTV)',
    description: 'Follow the GMTV rollout and watch global gospel media content.',
    image: importedSiteImages.mediaGmtv,
    cta: 'Watch',
    href: '/gmtv',
  },
  {
    title: 'Dominion Mandate Radio',
    description: 'Stay connected to radio programming and daily encouragement.',
    image: importedSiteImages.mediaRadio,
    cta: 'Listen',
    href: '/features/radio',
  },
] as const;

export const mentorshipCopy = {
  title: 'Global Leadership Forum',
  description:
    'A mentorship & training platform established for human capital development & transformational leadership for exponential growth in performance & productivity in any field of endeavour - ministry, career, enterprise, politics, government etc.',
  supportEmail: 'mentorship@davidogbueli.org',
  supportPhones: ['+234-7060574969', '+234-8038246281'],
  steps: [
    'Subscribe & follow Dr David Ogbueli on socials for quick access to resources & event updates.',
    'Fill the registration form and select the level of membership of your choice.',
  ],
} as const;

export const ministryCards = [
  { ...ministries[0], image: importedSiteImages.ministryDominionCity },
  { ...ministries[1], image: importedSiteImages.ministryGlf },
  { ...ministries[2], image: importedSiteImages.ministryGmn },
  { ...ministries[3], image: importedSiteImages.ministryDli },
  { ...ministries[4], image: importedSiteImages.ministryGhf },
  { ...ministries[5], image: importedSiteImages.ministryHuram },
  { ...ministries[6], image: importedSiteImages.ministryPriesthood },
] as const;

export const testimonyHighlights = [
  {
    title: 'Personal Transformation',
    body: "Dr. David's journey began with a clear call to transformation ministry. His passion for Personal Transformation and National Transformation has birthed various initiatives and ministries causing positive change among youth, governments, corporate institutions, and media stakeholders.",
  },
  {
    title: 'Global Recognition',
    body: 'Honoured by the United Nations, state governments, and government agencies for youth development projects, especially the annual National Youth Summit that empowers over 50,000 youths annually across Africa.',
  },
  {
    title: 'Building Leaders',
    body: 'Through Golden Heart Foundation, Dominion Leadership Institute, and the Global Leadership Forum, thousands have been trained and equipped for transformational leadership across seven continents.',
  },
];

export const visionPillars = [
  {
    icon: 'Target' as const,
    title: 'Raising Leaders',
    description: 'Our core vision is to raise leaders who transform society. Every believer carries the potential to influence their sphere of life for Christ.',
  },
  {
    icon: 'Globe' as const,
    title: 'Global Impact',
    description: 'From Africa to Europe, North America and beyond \u2014 Dominion Mandate is building a network of leaders transforming communities worldwide.',
  },
  {
    icon: 'Eye' as const,
    title: 'Total Transformation',
    description: 'Spiritual, mental, and social. Committed to the total transformation of the individual \u2014 because transformed people transform nations.',
  },
];

export const aboutHubIcons = ['User', 'BookOpen', 'Eye'] as const;

export const broadcastCopy = {
  heroTitle: 'Watch & Listen',
  heroSubtitle:
    'Experience the presence of God through our live services, recorded messages, and exclusive member content.',
  heroPublicLabel: 'Media Center',
  heroPrivateLabel: 'Private Broadcast',
  heroPublicDescription: 'Open access to live services and recorded messages for every visitor.',
  heroPrivateDescription: 'Members-only teachings and special sessions reserved for signed-in accounts.',
  publicTitle: 'Media Center',
  publicDescription: 'Watch our live services and browse recorded messages — freely available to everyone. No account needed.',
  publicLiveLabel: 'Live Services',
  publicLiveDescription: 'Join our worship services as they happen',
  publicLiveSchedule: 'Sundays 9 AM & 11 AM WAT',
  publicOnDemandLabel: 'On-Demand Messages',
  publicOnDemandDescription: 'Browse our library of sermons and teachings',
  publicPrimaryCta: 'Watch Live',
  publicSecondaryCta: 'Browse Media',
  privateTitle: 'Private Broadcast',
  privateDescription: 'Exclusive teachings, special sessions, and members-only events. Sign in to access content reserved for our community.',
  privateAccessLabel: 'Member Access',
  privateAccessDescription: 'Sign in to watch exclusive broadcasts, special conferences, and members-only content',
  privatePrimaryCta: 'Access Private Broadcast',
  privateSecondaryCta: 'Sign In to Continue',
};
